<template>
  <div class="row" style="padding-left: 16px;"  v-show="isBottomNav">
    <div class="simple-photo-bottom pl-0">
      <div class="row">
        <div class="col-2 pt-2 text-right">
          <span class="selimgs">
            <i class="fa-regular fa-image mr-2" aria-hidden="true" style="color: #737373"></i>
            <sup>{{selectedImages.length}}</sup>
            <span class="font-10">Ausgewählte Fotos:</span>
          </span>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 pl-0 pos-rel screen-height" style="max-height: 57px; overflow-x: hidden; overflow-y: auto;">
          <ul class="float-left img-thumb-list">
            <li v-for="(img , index) in selectedImages">
              <img height="50" width="50" :src="img.src" alt="img1">
              <a @click="unCheckImage(index)" href="javascript:void(0)">x</a>
            </li>
          </ul>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 pt-2 pr-2 pl-0 bottom-bar-photos text-left">
          <a href="#" class="black-text position-absolute" @click="closeBottomNav">
            <i class="fa fa-times" aria-hidden="true"></i>
          </a>

          <button type="button" class="btn btn-light" @click="selectAllImages">Alle auswählen </button>
          <button type="button" class="btn btn-light" @click="unselectAllImages" :disabled="!(selectedImages.length>0)">Auswahl aufheben </button>
          <button type="button" class="btn btn-light" @click="makeSpecialPhotoDocument" :disabled="!usercan('editor') || !(selectedImages.length>0)">Dokumentation erstellen</button>


          <button type="button" class="btn btn-light" @click="makeTicket" :disabled="!usercan('editor') || !(selectedImages.length>0)">Ticket erstellen</button>

          <button type="button" class="btn btn-light" @click="saveAsZipArchiv" :disabled="!(selectedImages.length>0)">ZIP-Datei herunterladen </button>
<!--          <button type="button" class="btn btn-light">Hinzufügen </button>-->
<!--          <button type="button" data-toggle="modal" data-target=".selectionModal" class="btn btn-light">{{$t("save_selection")}} </button>-->
<!--          <button type="button" data-toggle="modal" data-target=".herunteriadenModal" class="btn btn-light"> {{$t("download_selection")}} </button>-->
<!--          <button type="button" data-toggle="modal" data-target=".emailModal" class="btn btn-light"> {{$t("send_by_email")}} </button>-->
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'

export default {
  name: 'BottomNav',
  data () {
    return {
      currentPhotos: []
    }
  },
  computed: {
   ...mapState({
     doc: state =>  state.photoDocumentation.newDocumentDetails,
     selectedImages: state => state.photo.selectedPhotos,
     isBottomNav: state => state.photo.isBottomNav,
     allImages: state => state.photo.photos
   }),
    photos () {
      return this.$store.state.photo.canvasPhotos
    },
  },
  methods: {
    closeBottomNav () {
      this.$store.commit('emptySelectedImages', [])
      this.$store.commit('imageSelectableToggle')
      this.unselectAllImages()
    },

    makeTicket() {
      this.$store.state.tickets.createmode = true
      this.$router.push({name: 'Tickets', params: {id: this.$route.params.id}})
    },

    unCheckImage (index) {
      this.$store.state.photo.selectedPhotos.splice(index, 1)
      // this.$store.commit('unSelectImage', index)
    },

    selectAllImages () {
      // this.$store.state.photo.selectedPhotos
      let _this = this
      let selectedImages = []

      console.log('Add All Images', this.photos, _this.allImages, _this.$store.state.photo.selectedPhotos)

      this.photos.forEach(function(image, idx) {
        selectedImages.push(image.pdphotoid)

        _this.allImages.forEach(function(aimage, aidx) {
          if(aimage.pdphotoid == image.pdphotoid) {

            if (_this.$store.state.photo.selectedPhotos.filter((img) => img.pdphotoid == aimage.pdphotoid).length <= 0) {
              _this.$store.state.photo.selectedPhotos.push(aimage)
            }
          }
        })

        // if (_this.$store.state.photo.selectedPhotos.filter((img) => img.pdphotoid == image.pdphotoid)) {
        //   _this.$store.state.photo.selectedPhotos.push(_this.photos[idx])
        // }
      })
    },
    unselectAllImages () {
      let _this = this
      _this.$store.state.photo.selectedPhotos = []
    },

    saveAsZipArchiv: function() {

      let photoids = []
      let projectid = 0

      this.selectedImages.forEach(function(val, idx) {
        photoids.push(val.pdphotoid)
        projectid = val.projectid
      })

      let projectidlist = photoids.join()

      fetch(
        process.env.VUE_APP_GET_METHOD_URL + `archive&type=photo&projectid=` + projectid  + `&id=[` + projectidlist + `]&PHPSESSID=` + localStorage.sessiontoken + `&token=` + localStorage.sessiontoken,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/zip'
          }
        }
      )
        .then(response => response.blob())
        .then(response => {
          const blob = new Blob([response], { type: 'application/zip' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          let dateobj = new Date();
          // Datrum-ProjectdocuFotoexport
          link.download = moment().format('YYYY-MM-DD') + ' ProjectdocuFotoexport.zip'
            // + dateobj.getTime()
          link.click()
          URL.revokeObjectURL(link.href)
        })


      // axios.post(process.env.VUE_APP_BASE_AMF_URL + `getZipArchive&token=` + localStorage.sessiontoken,{
      //   "methodName": "getImagesAsZIP",
      //   "serviceName": "ProjectdocuService",
      //   "parameters": [photoids]
      // }, {
      //     headers: {
      //       apitoken: localStorage.apikey,
      //       deviceid: localStorage.deviceid
      //     }
      //   })
      //   // .then(response => response.blob())
      //   // .then(response => {
      //   //   console.log('Respoinse for Zip Download', response)
      //   //   // const blob = new Blob([response.data], { type: 'application/zip' })
      //   //   const link = document.createElement('a')
      //   //   link.href = URL.createObjectURL(response)
      //   //   link.download = 'Ziparchiv'
      //   //   link.click()
      //   //   URL.revokeObjectURL(link.href)
      //   // })
      //   .then(response => {
      //     console.log('Respoinse for Zip Download', response)
      //     const blob = new Blob([response.data], { type: 'application/zip' })
      //     const link = document.createElement('a')
      //     link.href = URL.createObjectURL(blob)
      //     link.download = 'Ziparchiv'
      //     link.click()
      //     URL.revokeObjectURL(link.href)
      //   })
      //   .catch(console.error)

    },



    /**
     * Move Selected Photos to Document Module For Special report
     */
    makeSpecialPhotoDocument(){
      let photosCopy = []
      const photos = this.selectedImages.map(photo => {
        const img = {
          pdphotoid: photo.pdphotoid,
          pdphototext: photo.description,
          description: photo.description,
          pduserid: photo.pduserid,
          runid: photo.runid,
          projectid: photo.projectid,
          photodate: photo.photodate,
          params: photo.params,
          origname: photo.origname
        }
        let imgCpy = JSON.parse(JSON.stringify(img))
        photosCopy.push(imgCpy)
        return img
      })
      this.$store.commit('setSelectedImages',[...photos])
      this.$store.commit('setTempPhotos',[...photosCopy])
      this.doc.reporttype = "1"
      this.$router.push({name: 'photoDocumentCreate',params: {id: this.$route.params.id}})
    }

  }
}
</script>
<style scoped>
.bottom-bar-photos a.position-absolute {
  position: absolute!important;
  right: 16px;
  top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/photo/components/BottomNav.vue